<template>
    <div :class="classese" :style="styles">
        <div :class="`${prefix}`">
            <slot></slot>
        </div>
    </div>
</template>

<script>
const prefix = 'u-flex-box'

export default {
    props: {
        // 比例; 默认1比1
        scale: {
            type: String,
            default: '1 / 1'
        }
    },
    data() {
        return {
            prefix
        }
    },
    methods: {
    },
    computed: {
        classese() {
            return [`${prefix}-wrap`]
        },
        styles() {
            return { paddingTop: `${eval(this.scale) * 100}%` }
        }
    }
}
</script>

<style lang="scss">
$prefixCls: u-flex-box;

.#{$prefixCls}-wrap {
    position: relative;
    .#{$prefixCls} {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
}
</style>
